module.exports = __webpack_public_path__ + "img/neck_male.b95d0751.png";